// Generated with util/create-component.js
import Legend from './Legend';

export default Legend;
